export default __webpack_public_path__ + "static/media/iconSqft.fead6a7e.svg";